const EmptyProduct = ({
  className,
  height = '240',
}: {
  className?: string;
  height?: string;
}) => (
  <svg
    width="327"
    height={height}
    viewBox="0 0 327 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Name=empty_cart, Shape=-">
      <g id="&#240;&#159;&#165;&#173;illustrations" opacity="0.2">
        <path
          id="background"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 132.52C0 160.159 10.1815 185.344 26.936 204.378C46.157 226.221 74.0295 239.954 105.098 240C118.677 240.02 131.66 237.409 143.585 232.642C149.752 230.177 156.653 230.46 162.625 233.381C169.631 236.803 177.475 238.721 185.759 238.721C189.18 238.721 192.531 238.391 195.773 237.766C205.025 235.985 213.444 231.772 220.359 225.805C224.704 222.054 230.27 220.168 235.958 220.175H236.054C254.849 220.175 272.308 214.353 286.802 204.378C299.76 195.471 310.342 183.247 317.393 168.894C323.54 156.387 327 142.259 327 127.305C327 76.0181 286.279 34.4356 236.054 34.4356C230.934 34.4356 225.918 34.8772 221.024 35.7012C208.066 14.28 184.861 0 158.39 0C147.213 0 136.618 2.54512 127.134 7.10748C118.114 11.4322 110.095 17.5775 103.535 25.0667C81.2604 25.4293 60.6639 32.86 43.8064 45.261C17.2707 64.7702 0 96.5882 0 132.52Z"
          fill="url(#paint0_linear_0_9532)"
        />
      </g>
      <g id="#gr">
        <path
          id="Shape"
          opacity="0.545118"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M184.574 26.5563C186.236 28.2193 188.42 29.0504 190.605 29.0504C192.789 29.0504 194.973 28.2193 196.635 26.5563C199.961 23.231 199.961 17.8199 196.635 14.494C193.31 11.1681 187.898 11.1693 184.574 14.494C181.248 17.8193 181.248 23.2304 184.574 26.5563ZM188.732 18.6534C189.249 18.1369 189.927 17.8793 190.605 17.8793C191.282 17.8793 191.96 18.1375 192.476 18.6534C193.508 19.6857 193.508 21.3651 192.476 22.3969C191.443 23.4293 189.765 23.4287 188.732 22.3969C187.701 21.3646 187.701 19.6851 188.732 18.6534Z"
          fill="#C4CDD5"
        />
        <path
          id="Shape_2"
          opacity="0.545118"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.521 225.7C119.183 227.362 121.368 228.194 123.552 228.194C125.736 228.194 127.921 227.363 129.583 225.7C132.909 222.375 132.909 216.963 129.583 213.638C126.258 210.312 120.845 210.312 117.521 213.638C114.195 216.963 114.195 222.374 117.521 225.7ZM121.68 217.797C122.196 217.28 122.874 217.023 123.552 217.023C124.23 217.023 124.908 217.281 125.424 217.797C126.455 218.829 126.455 220.509 125.424 221.54C124.391 222.573 122.713 222.573 121.68 221.54C120.648 220.508 120.648 218.829 121.68 217.797Z"
          fill="#C4CDD5"
        />
        <path
          id="Path"
          d="M272.674 188.022C271.922 188.022 271.168 187.735 270.595 187.16L267.086 183.652L263.577 187.16C262.429 188.309 260.566 188.309 259.418 187.16C258.269 186.012 258.269 184.149 259.418 183.001L265.006 177.413C266.154 176.265 268.018 176.265 269.165 177.413L274.754 183.001C275.902 184.15 275.902 186.012 274.754 187.16C274.18 187.734 273.426 188.022 272.674 188.022Z"
          fill="#DFE3E8"
        />
        <path
          id="Path_2"
          d="M65.2259 176.816C64.4735 176.816 63.72 176.529 63.1465 175.955L59.6377 172.446L56.1288 175.955C54.9812 177.103 53.1177 177.103 51.97 175.955C50.8212 174.806 50.8212 172.943 51.97 171.795L57.5583 166.207C58.7059 165.059 60.5694 165.059 61.7171 166.207L67.3053 171.795C68.4541 172.944 68.4541 174.806 67.3053 175.955C66.7312 176.528 65.9783 176.816 65.2259 176.816Z"
          fill="#D5DBE0"
        />
      </g>
      <g id="#gr_2" filter="url(#filter0_d_0_9532)">
        <g id="Shopping cart_Outline (1)">
          <rect
            id="Rectangle"
            opacity="0.24"
            x="126.791"
            y="74.1899"
            width="91.3322"
            height="99.835"
            rx="5.26316"
            fill="#919EAB"
            fillOpacity="0.16"
            stroke="#919EAB"
            strokeWidth="1.2"
            strokeDasharray="2 2"
          />
          <rect
            id="Rectangle_2"
            opacity="0.8"
            x="109.064"
            y="89.2101"
            width="74.8696"
            height="93.9854"
            rx="5.26316"
            fill="#919EAB"
            fillOpacity="0.16"
            stroke="#919EAB"
            strokeWidth="1.2"
            strokeDasharray="2 2"
          />
          <rect
            id="Rectangle_3"
            x="142.942"
            y="105.86"
            width="64.0786"
            height="80.2384"
            rx="5.26316"
            fill="#919EAB"
            fillOpacity="0.48"
            stroke="#919EAB"
            strokeWidth="1.2"
            strokeDasharray="2 2"
          />
          <rect
            id="Rectangle_4"
            x="120.179"
            y="141.361"
            width="86.8421"
            height="44.7368"
            fill="#C4CDD5"
          />
          <g id="Shape_3">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M95.6113 133.007L110.097 187.932C110.988 191.627 114.959 194.28 119.553 194.28H207.395C211.989 194.28 215.942 191.609 216.85 187.932L231.336 133.007H95.6113ZM134.092 179.207C134.092 181.406 131.795 183.196 128.973 183.196C126.15 183.196 123.871 181.415 123.871 179.207V147.501C123.871 145.302 126.15 143.513 128.973 143.513C130.274 143.491 131.545 143.901 132.588 144.679C133.507 145.329 134.065 146.376 134.092 147.501V179.207ZM157.099 179.207C157.099 181.406 154.82 183.196 151.997 183.196C149.175 183.196 146.887 181.415 146.887 179.207V147.501C146.887 145.302 149.175 143.513 151.997 143.513C153.28 143.503 154.53 143.913 155.559 144.679C156.475 145.331 157.029 146.377 157.054 147.501L157.099 179.207ZM180.115 179.207C180.115 181.406 177.826 183.196 175.004 183.196C172.182 183.196 169.902 181.415 169.902 179.207V147.501C169.902 145.302 172.182 143.513 175.004 143.513C176.305 143.492 177.576 143.902 178.619 144.679C179.535 145.331 180.089 146.377 180.115 147.501V179.207ZM203.13 179.207C203.13 181.406 200.851 183.196 198.028 183.196C195.206 183.196 192.909 181.415 192.909 179.207V147.501C192.909 145.302 195.206 143.513 198.028 143.513C199.326 143.493 200.594 143.903 201.634 144.679C202.551 145.331 203.105 146.377 203.13 147.501V179.207Z"
              fill="#DFE3E8"
            />
            <path
              d="M95.6113 133.007V132.257H94.6379L94.8861 133.198L95.6113 133.007ZM110.097 187.932L110.826 187.757L110.825 187.749L110.823 187.741L110.097 187.932ZM216.85 187.932L216.125 187.741L216.122 187.752L216.85 187.932ZM231.336 133.007L232.062 133.198L232.31 132.257H231.336V133.007ZM128.973 143.513V144.263L128.986 144.263L128.973 143.513ZM132.588 144.679L132.139 145.28L132.147 145.286L132.155 145.291L132.588 144.679ZM134.092 147.501H134.842V147.492L134.842 147.483L134.092 147.501ZM157.099 179.207H157.849L157.849 179.206L157.099 179.207ZM151.997 143.513V144.263L152.003 144.263L151.997 143.513ZM155.559 144.679L155.11 145.28L155.117 145.285L155.124 145.29L155.559 144.679ZM157.054 147.501L157.804 147.5L157.804 147.493L157.804 147.485L157.054 147.501ZM175.004 143.513V144.263L175.016 144.263L175.004 143.513ZM178.619 144.679L178.171 145.281L178.177 145.285L178.184 145.29L178.619 144.679ZM180.115 147.501H180.865V147.493L180.864 147.485L180.115 147.501ZM198.028 143.513V144.263L198.04 144.263L198.028 143.513ZM201.634 144.679L201.186 145.28L201.193 145.285L201.2 145.29L201.634 144.679ZM203.13 147.501H203.88V147.493L203.88 147.485L203.13 147.501ZM94.8861 133.198L109.372 188.124L110.823 187.741L96.3365 132.815L94.8861 133.198ZM109.368 188.108C110.361 192.23 114.714 195.03 119.553 195.03V193.53C115.203 193.53 111.614 191.025 110.826 187.757L109.368 188.108ZM119.553 195.03H207.395V193.53H119.553V195.03ZM207.395 195.03C212.238 195.03 216.567 192.209 217.579 188.112L216.122 187.752C215.318 191.01 211.74 193.53 207.395 193.53V195.03ZM217.576 188.124L232.062 133.198L230.611 132.815L216.125 187.741L217.576 188.124ZM231.336 132.257H95.6113V133.757H231.336V132.257ZM133.342 179.207C133.342 180.828 131.566 182.446 128.973 182.446V183.946C132.024 183.946 134.842 181.984 134.842 179.207H133.342ZM128.973 182.446C126.382 182.446 124.621 180.839 124.621 179.207H123.121C123.121 181.991 125.919 183.946 128.973 183.946V182.446ZM124.621 179.207V147.501H123.121V179.207H124.621ZM124.621 147.501C124.621 145.877 126.383 144.263 128.973 144.263V142.763C125.917 142.763 123.121 144.727 123.121 147.501H124.621ZM128.986 144.263C130.12 144.243 131.229 144.601 132.139 145.28L133.036 144.078C131.861 143.2 130.427 142.738 128.96 142.763L128.986 144.263ZM132.155 145.291C132.881 145.805 133.321 146.631 133.343 147.52L134.842 147.483C134.809 146.121 134.134 144.853 133.021 144.067L132.155 145.291ZM133.342 147.501V179.207H134.842V147.501H133.342ZM156.349 179.207C156.349 180.831 154.587 182.446 151.997 182.446V183.946C155.053 183.946 157.849 181.981 157.849 179.207H156.349ZM151.997 182.446C149.405 182.446 147.637 180.838 147.637 179.207H146.137C146.137 181.992 148.945 183.946 151.997 183.946V182.446ZM147.637 179.207V147.501H146.137V179.207H147.637ZM147.637 147.501C147.637 145.879 149.406 144.263 151.997 144.263V142.763C148.944 142.763 146.137 144.726 146.137 147.501H147.637ZM152.003 144.263C153.122 144.254 154.213 144.612 155.11 145.28L156.007 144.078C154.847 143.214 153.438 142.752 151.992 142.763L152.003 144.263ZM155.124 145.29C155.847 145.805 156.285 146.631 156.305 147.518L157.804 147.485C157.774 146.124 157.103 144.857 155.993 144.068L155.124 145.29ZM156.304 147.502L156.349 179.208L157.849 179.206L157.804 147.5L156.304 147.502ZM179.365 179.207C179.365 180.83 177.595 182.446 175.004 182.446V183.946C178.057 183.946 180.865 181.982 180.865 179.207H179.365ZM175.004 182.446C172.413 182.446 170.652 180.839 170.652 179.207H169.152C169.152 181.991 171.95 183.946 175.004 183.946V182.446ZM170.652 179.207V147.501H169.152V179.207H170.652ZM170.652 147.501C170.652 145.877 172.414 144.263 175.004 144.263V142.763C171.949 142.763 169.152 144.727 169.152 147.501H170.652ZM175.016 144.263C176.151 144.244 177.26 144.602 178.171 145.281L179.067 144.078C177.891 143.202 176.458 142.739 174.992 142.763L175.016 144.263ZM178.184 145.29C178.907 145.805 179.345 146.631 179.365 147.518L180.864 147.485C180.834 146.124 180.163 144.857 179.054 144.068L178.184 145.29ZM179.365 147.501V179.207H180.865V147.501H179.365ZM202.38 179.207C202.38 180.831 200.618 182.446 198.028 182.446V183.946C201.084 183.946 203.88 181.981 203.88 179.207H202.38ZM198.028 182.446C195.434 182.446 193.659 180.836 193.659 179.207H192.159C192.159 181.994 194.978 183.946 198.028 183.946V182.446ZM193.659 179.207V147.501H192.159V179.207H193.659ZM193.659 147.501C193.659 145.88 195.435 144.263 198.028 144.263V142.763C194.977 142.763 192.159 144.725 192.159 147.501H193.659ZM198.04 144.263C199.172 144.246 200.278 144.603 201.186 145.28L202.083 144.078C200.91 143.203 199.48 142.741 198.017 142.763L198.04 144.263ZM201.2 145.29C201.923 145.805 202.36 146.631 202.38 147.518L203.88 147.485C203.85 146.124 203.178 144.857 202.069 144.068L201.2 145.29ZM202.38 147.501V179.207H203.88V147.501H202.38Z"
              fill="#919EAB"
              fillOpacity="0.48"
            />
          </g>
          <circle
            id="Oval"
            cx="154.579"
            cy="53.605"
            r="8.28917"
            fill="#DFE3E8"
            stroke="#919EAB"
            strokeOpacity="0.48"
            strokeWidth="1.5"
          />
          <path
            id="Path_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M113.614 127.371C111.902 128.133 109.893 127.697 108.652 126.293C107.411 124.888 107.225 122.841 108.192 121.236L151.151 51.0408C151.946 49.7303 153.38 48.9436 154.913 48.977C156.445 49.0104 157.844 49.8589 158.581 51.2029C159.318 52.5468 159.283 54.182 158.488 55.4926L115.537 125.688C115.083 126.432 114.412 127.019 113.614 127.371Z"
            fill="#DFE3E8"
            stroke="#919EAB"
            strokeOpacity="0.48"
            strokeWidth="1.5"
          />
          <circle
            id="Oval_2"
            cx="172.368"
            cy="53.605"
            r="8.28917"
            fill="#DFE3E8"
            stroke="#919EAB"
            strokeOpacity="0.48"
            strokeWidth="1.5"
          />
          <path
            id="Path_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M213.378 127.371C215.09 128.133 217.098 127.697 218.339 126.292C219.58 124.888 219.767 122.841 218.8 121.236L175.84 51.0408C174.611 49.0149 171.972 48.3691 169.946 49.5984C167.92 50.8277 167.275 53.4666 168.504 55.4925L211.455 125.688C211.909 126.432 212.58 127.019 213.378 127.371Z"
            fill="#DFE3E8"
            stroke="#919EAB"
            strokeOpacity="0.48"
            strokeWidth="1.5"
          />
          <rect
            id="Rectangle_5"
            x="86.4316"
            y="117.915"
            width="154.075"
            height="15.0914"
            rx="7.54572"
            fill="#DFE3E8"
            stroke="#919EAB"
            strokeOpacity="0.48"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_0_9532"
        x="73.6816"
        y="32.5659"
        width="203.575"
        height="198.465"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12" dy="12" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_9532"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_9532"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_0_9532"
        x1="224.002"
        y1="282.688"
        x2="340.012"
        y2="15.5039"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#919EAB" />
        <stop offset="1" stopColor="#919EAB" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default EmptyProduct;
